import React from "react";
import { useEffect, useState } from "react";

import "./catering-product-list-theme2.scss";
import CateringProductCardTheme2 from "../CateringProductCardTheme2";
import { useGetCateringProducts } from 'hooks/useGetCateringProducts';
import { useGetCateringTree } from 'hooks/useGetCateringTree';
import { useSearchParams } from 'react-router-dom';
import useSmoothScroll from 'hooks/useSmoothScroll';
import { querySearchParamKey } from 'components/ProductListingPageNew/SidebarNew/DepartmentListItemNew';

// const NO_OF_PRODUCTS_TO_SHOW = 9

function CateringCategoryWiseProducts() {
  const {
    data: cateringDepartmentTree,
    isLoading: cateringDepartmentTreeLoading,
  } = useGetCateringTree()
  
  // let categories = cateringDepartmentTree?.[0]?.node
  let categories = cateringDepartmentTree?.map(c => c?.node).flat()
  categories?.sort((a, b) => +a.order_by - +b.order_by)
  
  const {data: cateringProducts, isLoading: cateringProductsLoading } = useGetCateringProducts()
  
  const [searchParams] = useSearchParams();
  const scrollToCategory = useSmoothScroll()
  useEffect(() => {
    if (!cateringProducts?.length) {
      return
    }
    
    const categorySlug = searchParams.get(querySearchParamKey)
    if (categorySlug) {
      scrollToCategory(`catering-category-${categorySlug}`, 300, 275)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cateringProducts]);
  
  if (cateringDepartmentTreeLoading || cateringProductsLoading) {
    return null
  }
  
  return categories?.map(category => {
    const products = cateringProducts?.filter(i => i.parent_category === category?.category_ids)
    return <CateringProductListTheme2 key={category.category_id} category={category} products={products} />
  })
}

const CateringProductListTheme2 = ({ category, products }) => {
  const [showAll] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(9);
  
  const [isCateringMenuActive, setCateringMenuActive] = useState(false);
  const toggleCateringMenu = () => {
    setCateringMenuActive(!isCateringMenuActive);
  };
  
  const CloseCateringMenu = () => {
    setCateringMenuActive(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setItemsToShow(3);
      } else if (window.innerWidth <= 767) {
        setItemsToShow(3);
      } else if (window.innerWidth <= 1300) {
        setItemsToShow(5);
        } else if (window.innerWidth <= 1600) {
      setItemsToShow(7);
      } else {
        setItemsToShow(9);
      }
    };

      handleResize();
      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
  useEffect(() => {
    if (isCateringMenuActive){
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    
    return()=>{
      document.body.style.overflow = "auto";
    };
  }, [isCateringMenuActive]);
  
  if (!products?.length) {
    return null
  }
  
  const visibleProducts = showAll
  ? products
  // : products?.slice(0, NO_OF_PRODUCTS_TO_SHOW);
  :products.slice(0, itemsToShow);
  

  return (
    <div>
      <div className="department-product department-product--theme2">
        <h2 id={`catering-category-${category?.slug}`}>{category.text}</h2>
         {/* {!showAll && products?.length > itemsToShow && (
        <button className="see-more"  onClick={toggleCateringMenu}>See More <i className="fa-solid fa-angle-right"></i></button>
          )} */}
      </div>
      <div style={{position:'relative'}}>

      <div className={`catering-product-overlay ${isCateringMenuActive ? 'active' : ''}`}></div>
      <div className={`catering-sidebar ${isCateringMenuActive ? 'active' : ''}`}>
          <div className="close-mobile-menu" onClick={CloseCateringMenu}><i className="fa-solid fa-xmark"></i></div>
          <div className="title department-product department-product--theme2">
            <h2 id={`catering-category-${category?.slug}`}>{category.text}</h2>
          </div>
      <div className="catering-product-list-grid-2">
          {products?.map((product) => {
            return (
              <div
                className="catering-product-list-grid-items"
                key={product.product_id}
              >
                <CateringProductCardTheme2 product={product} />
              </div>
            );
          })}
        </div>
        </div>
      </div>

      <div className="catering-list-2">
     <div className={visibleProducts?.length <= 3 ? "catering-product-theme-ui" : "catering-product-list-grid-2"}>
          {(showAll ? products : products?.slice(0, itemsToShow))?.map((product) => (
        <div
          className="catering-product-list-grid-items"
          key={product.product_id}
        >
          <CateringProductCardTheme2 product={product} />
        </div>
      ))}

      {!showAll && products?.length > itemsToShow && (
           <div className="product-seemore catering-product-card-2">
            <div className="product-text">
            Explore More {category.text} Items
        <button className="see-more"  onClick={toggleCateringMenu}>See More</button>
            </div>
          </div>
      )}
      </div>
      </div>
    </div>
  );
};

export default CateringCategoryWiseProducts